export function createNumber(min, max) {
	return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function createComparisonNumber(min, max) {
	var firstNumber = createNumber(min, max),

		selectEqual = createNumber(1, 8) == 1 ? true : false,
		numberSet;

	if(selectEqual) {
		numberSet = { leftNumber: firstNumber, rightNumber: firstNumber };
	} else {
		numberSet = { leftNumber: firstNumber, rightNumber: createNumber(min, max) };
	}	
  return numberSet;
}

export function checkComparisonAnswer(leftNumber, rightNumber, symbol) {
	if(symbol == '=' && (leftNumber == rightNumber)) {
		return true;
	} else if (symbol == '>' && (leftNumber > rightNumber)) {
		return true;
	}	else if (symbol == '<' && (leftNumber < rightNumber))	{
		return true;
	}	else {
		return false;
	}
}

export function feedbackSentence(leftNumber, rightNumber, symbol){
	var middle_part;
	var sentence = '';
	var isCorrectAnswer = checkComparisonAnswer(leftNumber, rightNumber, symbol);
	
	if(symbol == '<') {
		middle_part = 'less than';
	} else if(symbol == '=') {
		middle_part = 'equal to';
	} else {
		middle_part = 'greater than';
	}

	sentence = `${leftNumber.toLocaleString()} is${isCorrectAnswer ?
		' ' : ' not '}${middle_part} ${rightNumber.toLocaleString()}`;
	return sentence;
}

export function printNumber(number){
	return number.toLocaleString();
}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/inequality/lib/inequality.js
 **/